import React, { useState } from 'react';
import { Tune, ArrowBackIos } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Header } from '../../components/header/header';
import { ButtonIconStyled, TitleStyled } from '../devices/devicesStyles';
import { HealthTemplate } from '../../templates/healthTemplate/healthTemplate';
import Strings from '../../i18n';
import { ContainerStyled } from '../locations/locationStyles';

export const HealthMonitorView = () => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState('');

  return (
    <>
      <Header>
        <ContainerStyled>
          <div className="row justify-content-between">
            <div className="col-4 text-left">
              <ButtonIconStyled size="small" onClick={() => navigate(-1)}>
                <ArrowBackIos />
              </ButtonIconStyled>
            </div>
            <div className="col-4 text-center">
              <TitleStyled>
                {Strings.serverAccess.menu.serviceHealth}
              </TitleStyled>
            </div>
            <div className="col-4 text-right">
              <ButtonIconStyled size="small">
                <Tune />
              </ButtonIconStyled>
            </div>
          </div>
        </ContainerStyled>
      </Header>
      <HealthTemplate />
    </>
  );
};
